import { Component, OnInit, HostListener, ViewChild, ElementRef } from '@angular/core';
import { Routes } from '@angular/router';
import { Contact } from '../contact';
import { ContactList } from '../contactList';
import { Title } from '@angular/platform-browser'
import { HttpClient } from '@angular/common/http';
import { trigger, state, style, animate, transition, keyframes } from '@angular/animations';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { fromEvent } from 'rxjs';

const rubber = [false];

// fromEvent(document, 'mousemove').subscribe((e: MouseEventInit) => {
//   if (rubber[0] == true) {
//     console.log("Im in");
//   }
// });

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css', './mobile-style/mobile.css'],
  animations: [
    trigger('movingIn', [
      state('before', style({
        opacity: 0,
        transform: 'translateX(10%)',
      })),
      state('after1', style({
        opacity: 1,
        transform: 'translateX(0)',
      })),
      state('after2', style({
        opacity: 1,
        transform: 'translateX(0)',
      })),
      state('after3', style({
        opacity: 1,
        transform: 'translateX(0)',
      })),
      state('beforeTitle', style({
        opacity: 0,
        transform: 'translateY(50%)'
      })),
      state('afterTitle', style({
        opacity: 1,
        transform: 'translateY(0)'
      })),
      state('beforeSec', style({
        opacity: 0,
      })),
      state('afterSec', style({
        opacity: 1,
      })),

      transition('before => after1', [animate('0.5s ease')]),
      transition('before => after2', [animate('0.5s 0.25s ease')]),
      transition('before => after3', [animate('0.5s 0.5s ease')]),
      transition('beforeTitle => afterTitle', [animate('0.5s 0.15s ease')]),
      transition('beforeSec => afterSec', [animate('1.5s 0.15s ease')])
    ]),

    trigger('introIn',[
      transition(':enter', [style({
        transform: 'scale(1.5)',
        opacity: 0
      }), animate('1.5s ease', style({ 
        transform: 'scale(1)',
        opacity: 1
       }))])
    ]),

    trigger('introDescIn', [
      transition(':enter', [style({
        transform: 'scale(1.5)',
        opacity: 0
      }), animate('1.5s 0.6s ease', style({
        transform: 'scale(1)',
        opacity: 1
      }))])
    ]),

    trigger('goalHover',[
      state('beforeHover', style({

      })),
      state('goal1Icon', style({
        backgroundImage: "url(assets/images/quality-colored-icon.png)",
        transform: 'scale(1.1)'
      })),
      state('goal2Icon', style({
        backgroundImage: "url('assets/images/environment-2-colored.png')",
        transform: 'scale(1.1)'
      })),
      state('goal3Icon', style({
        backgroundImage: "url('assets/images/innovation-colored-icon.png')",
        transform: 'scale(1.1)'
      })),
      state('goal4Icon', style({
        backgroundImage: "url('assets/images/productive-colored-icon.png')",
        transform: 'scale(1.1)'
      })),
      state('goal5Icon', style({
        backgroundImage: "url('assets/images/protection-colored-icon.png')",
        transform: 'scale(1.1)'
      })),
      state('fontHover', style({
        transform: 'scale(1.1)'
      })),
      

      transition('beforeHover <=> fontHover', animate('0.3s ease')),
      transition('beforeHover <=> goal1Icon', animate('0.3s ease')),
      transition('beforeHover <=> goal2Icon', animate('0.3s ease')),
      transition('beforeHover <=> goal3Icon', animate('0.3s ease')),
      transition('beforeHover <=> goal4Icon', animate('0.3s ease')),
      transition('beforeHover <=> goal5Icon', animate('0.3s ease'))
    ]),

    trigger('divCollapsed', [
      state('collapse', style({
        height: "0px"
      })),
      state('historyCollapse', style({
        height: "0px",
        paddingBottom: "0px"
      })),
      state('expand', style({  }), {params: {divHeight: '400px'}}),

      transition('collapse <=> expand', [animate('0.8s ease')]),
      transition('historyCollapse <=> expand', [animate('0.8s ease')])
    ]),

    trigger('sustainChange', [
      state('before', style({  })),
      state('hoverEnvironmentIcon', style({
        backgroundImage: "url('assets/images/environment-green-icon.png')"
      })),
      state('hoverEnvironmentFont', style({
        color: 'rgb(46, 209, 144)'
      })),
      state('hoverSocialIcon', style({
        backgroundImage: "url('assets/images/social-blue-icon.png')"
      })),
      state('hoverSocialFont', style({
        color: 'rgb(124, 135, 235)'
      })),
      state('hoverEconomyIcon', style({
        backgroundImage: "url('assets/images/supply-van-colored.png')"
      })),
      state('hoverEconomyFont', style({
        color: 'rgb(204, 102, 0)'
      })),

      transition('before <=> hoverEnvironmentIcon, before <=> hoverEnvironmentFont', [animate('0.3s ease')]),
      transition('before <=> hoverSocialIcon, before <=> hoverSocialFont', [animate('0.3s ease')]),
      transition('before <=> hoverEconomyIcon, before <=> hoverEconomyFont', [animate('0.3s ease')])
    ]),

    trigger('heightFit', [
      state('achievedHeight', style({
        height: '{{sustainHeight}}'+'px'
      }), {params: {sustainHeight: '2100'}}), 
      state('futureHeight', style({
        height: '{{sustainHeight}}'+'px'
      }), {params: {sustainHeight: '1350'}}),
      transition('achievedHeight <=> futureHeight', animate('0.6s ease'))
    ]),

    trigger('historyButton', [
      state('hoverIn', style({
        opacity: '1'
      })),
      state('hoverOut', style({
        opacity: '0'
      })),
      transition('hoverIn <=> hoverOut', animate('0.2s ease'))
    ]),

    trigger('contactHover', [
      state('befLeft', style({
        opacity: '0',
        // transform: 'translateX(-70%)'
      })),
      state('befMid', style({
        opacity: '0',
        // transform: 'translateY(70%)'
      })),
      state('befRight', style({
        opacity: '0',
        // transform: 'translateX(70%)'
      })),
      state('after', style({
        opacity: '1',
        // transform: 'translate(0)',
        backgroundColor: 'rgb(230, 215, 215)'
      })),
      transition('befLeft <=> after', animate('0.4s ease')),
      transition('befMid <=> after', animate('0.4s ease')),
      transition('befRight <=> after', animate('0.4s ease'))
    ])
  ]
})

export class HomeComponent implements OnInit {
  smrOnHover = false;
  smrStatus = 'before'
  gradientIndex = 0;
  rotateAngleY = 0;
  rotateAngleX = 0;
  cursorAngle = 0;

  productOnScreen = false;
  formOnScreen = false;
  goalHover1 = false;
  goalHover2 = false;
  goalHover3 = false;
  goalHover4 = false;
  goalHover5 = false;
  panelHover1 = false;
  panelHover2 = false;
  panelHover3 = false;
  abt = true;
  goals = false;
  goalDesc = false;
  products = false;
  sustain = false;
  sustainIntro = false;
  contacts = false;
  locations = false;
  mapOnScreen = false;
  envHover = false;
  socialHover = false;
  ecoHover = false;
  achievedSelect = true;
  contactNumberHover = false;
  contactEmailHover = false;
  contactMediaHover = false;
  historyCollapsed = true;
  tabOnView = false;
  historyHover = false;
  collapseStatus = true;
  collapseString = "collapse";
  historyCollapseString = "historyCollapse";
  sustainabilityTab = "tab1";
  sustainabilityTabStatus = "achievedHeight";
  expandHeight = '980px';
  sustainHeight = 2100;
  contactForm!: FormGroup;
  contactItem!: Contact;
  contactList = ContactList;
  lat = 5.60398;
  lng = 102.20528;

  constructor(
    private formBuilder: FormBuilder,
    private titleService: Title,
    private http: HttpClient,
    ) { }

  ngOnInit(): void {
    this.contactForm = this.formBuilder.group({
      name: '',
      email: '',
      subject: '',
      message: ''
    })

    this.titleService.setTitle("Seng Hin Rubber (M) Sdn. Bhd.");
    this.getScreenWidth();
    console.log(navigator.language);
  }

  redirectToFb(): void {
    window.open("https://www.facebook.com/pages/Seng-Hin-Rubber-M-Sdn-Bhd/421439151296044", "_blank");
  }

  redirectToLink(): void {
    window.open("https://www.linkedin.com/in/lee-seng-pin-28ba90129/?originalSubdomain=my", "_blank");
  }

  redirectToJS(): void {
    window.open("https://www.jobstreet.com.my/en/companies/466047-seng-hin-rubber-m", "_blank");
  }

  onSubmit() {
    const headers = { 'content-type': 'application/json' };
    
    this.contactItem = this.contactForm.value;
    this.contactList.push(this.contactForm.value);
    this.contactForm.reset();
    var theJSON = JSON.stringify(this.contactItem);
    this.http.post('http://localhost:8000/api/post', theJSON, {'headers': headers}).subscribe((response)=> console.log(response));
    alert("We have received your message. We will be contacting you soon! Thanks for your patience.");
  }

  onActivate(event: Routes){
    window.scroll(0,0);
  }

  translateCheck(): boolean{
    if(window.location.port == "4201"){
      return true;
    }
    else{
      return false;
    }
  }

  @ViewChild("product") product!:ElementRef;
  @ViewChild("smrTable") smrTable!:ElementRef;
  @ViewChild("historyTab") historyTab!:ElementRef;
  @ViewChild("establishedYear") establishedYear!:ElementRef;
  collapseExpand(target:string) {
    if(target == "smrTable")
    {
      this.collapseStatus = !this.collapseStatus;

      if(this.collapseStatus) {
        this.scroll(this.product.nativeElement);
        this.collapseString = "collapse";
      }
      else {
        this.scroll(this.smrTable.nativeElement);
        this.collapseString = "expand";
      }
    }
    else if(target == "history")
    {
      this.historyCollapsed = !this.historyCollapsed;

      if(this.historyCollapsed){
        this.scroll(this.aboutSec.nativeElement);
        this.historyCollapseString = "historyCollapse";
      }
      else{
        this.scroll(this.establishedYear.nativeElement);
        this.historyCollapseString = "expand";
      }
    }
  }

  @ViewChild('smrRubber') smrRubber!:ElementRef;
  rubberOnHover(result: boolean) {
    rubber[0] = result;
    this.smrOnHover = result;

    const source = fromEvent(document, 'mousemove');
    var sub = source.subscribe((e: MouseEventInit) => {

      if(rubber[0]) {

      }
      else {
        this.smrStatus = 'before';
        sub.unsubscribe();
      }
    })
  }

  sustainabilityTabSwitch(currentTab:string) {
    if (currentTab == "achievedTab") {
      this.achievedSelect = true;
      this.sustainabilityTab = "tab1";
      this.sustainabilityTabStatus = "achievedHeight";
    }
    else if(currentTab == "futureTab") {
      this.achievedSelect = false;
      this.sustainabilityTab = "tab2";
      this.sustainabilityTabStatus = "futureHeight";
    }
    else {
      console.log("Error: Selected tab '" + currentTab + "' is not found.");
    }
    this.getScreenWidth();
  }

  getScreenWidth(){
    if(window.innerWidth > 1960)
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 2150;
      }
      else 
      {
        this.sustainHeight = 1500;
      }
    }
    else if(window.innerWidth < 1441 && window.innerWidth > 1024)
    {
      if(this.achievedSelect ==  true)
      {
        this.sustainHeight = 2200;
      }
      else 
      {
        this.sustainHeight = 1350;
      }
    }
    else if(window.innerWidth < 1025 && window.innerWidth > 863)
    {
      if(this.achievedSelect == true) 
      {
        this.sustainHeight = 2030;
      }
      else
      {
        this.sustainHeight = 1450;
      }
    }
    else if(window.innerWidth < 864 && window.innerWidth > 767)
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 2220;
      }
      else
      {
        this.sustainHeight = 1500;
      }
    }
    else if(window.innerWidth < 768 && window.innerWidth > 425)
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 1350;
      }
      else
      {
        this.sustainHeight = 2750;
      }
    }
    else if(window.innerWidth < 426 && window.innerWidth > 319)
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 1200;
      }
      else
      {
        this.sustainHeight = 2600;
      }
    }
    else if(window.innerWidth < 320)
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 3380;
      }
      else 
      {
        this.sustainHeight = 2400;
      }
    }
    else
    {
      if(this.achievedSelect == true)
      {
        this.sustainHeight = 2100;
      }
      else
      {
        this.sustainHeight = 1350;
      }
    }
  }

  scroll(el: HTMLElement){
    el.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
  }

  @ViewChild('historyContent') historyContent!:ElementRef;
  scrollHorizontal(direction:string){
    if(direction == "left")
    {
      this.historyContent.nativeElement.scrollTo({ left: (this.historyContent.nativeElement.scrollLeft - 700), behavior: 'smooth' });
    }
    else if(direction == "right")
    {
      this.historyContent.nativeElement.scrollTo({ left: (this.historyContent.nativeElement.scrollLeft + 700), behavior: 'smooth' });
    }
  }

  redirectToMap(): void {
    window.open("https://maps.google.com/maps?ll=5.603963,102.205282&z=16&t=m&hl=en&gl=MY&mapclient=embed&daddr=Seng%20Hin%20Rubber%20(M)%20Sdn.%20Bhd.%20No.%201%2C%20Jalan%20Stapuna%2C%20Kawasan%20Perindustrian%20Sungai%20Nal%2C%20Kelantan%2018000%20Kuala%20Krai@5.6039626,102.2052822", "_blank");
  }

  redirectToWaze(): void {
    window.open("https://ul.waze.com/ul?place=ChIJ-4i42mV8tjERQY6CvZWWzis&ll=5.60396260%2C102.20528220&navigate=yes&utm_campaign=default&utm_source=waze_website&utm_medium=lm_share_location", "_blank");
  }

  @ViewChild("panel") panel!: ElementRef;
  @ViewChild("form") form!: ElementRef;
  @ViewChild("aboutSec") aboutSec!:ElementRef;
  @ViewChild("goalSec") goalSec!:ElementRef;
  @ViewChild("productSec") productSec!:ElementRef;
  @ViewChild("goalContent") goalContent!:ElementRef;
  @ViewChild("sustainabilitySec") sustainabilitySec!:ElementRef;
  @ViewChild("contactSec") contactSec!:ElementRef;
  @ViewChild("locationSec") locationSec!:ElementRef;
  @ViewChild("sustainability") sustainability!:ElementRef;
  @ViewChild("sustainabilityIntro") sustainabilityIntro!:ElementRef;
  @ViewChild("map") map!:ElementRef;

  @HostListener('window:scroll')
  checkScroll(){
    const scrollPosition = window.pageYOffset + window.innerHeight;
    if (this.panel && this.panel.nativeElement.offsetTop <= scrollPosition)
    {
      this.productOnScreen = true;
    }
    else {
      this.productOnScreen = false;
    }

    if (this.form && this.form.nativeElement.offsetTop <= scrollPosition)
    {
      this.formOnScreen = true;
    }
    else {
      this.formOnScreen = false;
    }

    if (this.aboutSec && this.aboutSec.nativeElement.offsetTop <= scrollPosition)
    {
      this.abt = true;
    }
    else {
      this.abt = false;
    }

    if (this.goalSec && this.goalSec.nativeElement.offsetTop <= scrollPosition)
    {
      this.goals = true;
    }
    else {
      this.goals = false;
    }

    if (this.goalContent && this.goalContent.nativeElement.offsetTop <= scrollPosition)
    {
      this.goalDesc = true;
    }
    else {
      this.goalDesc = false;
    }

    if (this.productSec && this.productSec.nativeElement.offsetTop <= scrollPosition)
    {
      this.products = true;
    }
    else {
      this.products = false;
    }

    if (this.sustainabilitySec && this.sustainabilitySec.nativeElement.offsetTop <= scrollPosition)
    {
      this.sustain = true;
    }
    else {
      this.sustain = false;
    }

    if (this.sustainabilityIntro && this.sustainabilityIntro.nativeElement.offsetTop <= scrollPosition)
    {
      this.sustainIntro = true;
    }
    else {
      this.sustainIntro = false;
    }
    
    if (this.contactSec && this.contactSec.nativeElement.offsetTop <= scrollPosition)
    {
      this.contacts = true;
    }
    else {
      this.contacts = false;
    }

    if (this.locationSec && this.locationSec.nativeElement.offsetTop <= scrollPosition)
    {
      this.locations = true;
    }
    else {
      this.locations = false;
    }

    if (this.map && this.map.nativeElement.offsetTop <= scrollPosition)
    {
      this.mapOnScreen = true;
    }
    else {
      this.mapOnScreen = false;
    }
  }
}

